module.exports = __webpack_public_path__ + "c00fcab9801127d28b055781cc3bdfdc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/dashboard-grading.png
// module id = 1664
// module chunks = 0